import React, { useEffect, useState, useContext } from "react";
import { getSalesReport, getServiceReport } from "../../../Utility/Api";
import { getFormattedCurrentDate2, NaviGate, shop_id } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import "./table.css";
import * as XLSX from "xlsx";

const ServiceReport = () => {
  const { showLoader, hideLoader } = useContext(WarehouseContext);
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState(getFormattedCurrentDate2());
  const [toDate, setToDate] = useState(getFormattedCurrentDate2());
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate]);

  const fetchData = async () => {
    try {
      showLoader();
      const filter = `from_date=${fromDate}&to_date=${toDate}&shop_id=${shop_id}`;
      const response = await getServiceReport(filter);
      if (response.data && response.data.data) {
        setData(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
      }
      hideLoader();
    } catch (error) {
      hideLoader();
      console.error("Error fetching order data:", error);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchData(pageNumber);
  };

  const handleSelectCustomer = (event) => {
    setSelectedCustomer(event.target.value);
  };

  const handlePaymentFilter = (event) => {
    setPaymentStatus(event.target.value);
  };

  const filteredData = data.filter((cus) =>
    (selectedCustomer ? cus.customer_name === selectedCustomer : true) &&
    (paymentStatus === "paid" ? cus.purchase_unit !== 2 : paymentStatus === "unpaid" ? cus.purchase_unit === 2 : true)
  );

  const exportToExcel = () => {
    const exportData = filteredData?.filter((data) => data.status != "-1").map((item) => ({
      Date: item.date,
      "Service No": item.service_no,
      "Customer Name": item.customer_name,
      Amount: item.total_amount,
      "Payment Status": item.purchase_unit == 2 ? "UnPaid" : "Paid"
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Service_Report");
    XLSX.writeFile(wb, `Service_Report_${fromDate}_to_${toDate}.xlsx`);
  };

  return (
    <div className="page-wrappers">
      <div className="page-content py-1">
        <NaviGate />
        <form onSubmit={(e) => e.preventDefault()} className="card p-4 shadow-sm">
          <div className="row g-3 justify-content-end">
            <h5 className="mb-0 text-uppercase">Service Report</h5>
            <div className="col-md-2 position-relative">
              <div className="form-floating">
                <select className="form-control" value={paymentStatus} onChange={handlePaymentFilter}>
                  <option value="">All</option>
                  <option value="paid">Paid</option>
                  <option value="unpaid">Unpaid</option>
                </select>
                <label>Payment type</label>
              </div>
            </div>

            {/* Customer Selection */}
            <div className="col-md-2 ">
              <div className="form-floating">
                <select
                  className="form-control"
                  value={selectedCustomer || ""}
                  onChange={handleSelectCustomer}
                >
                  <option value="">All Customers</option>
                  {[...new Set(data.map((customer) => customer.customer_name).filter(Boolean))].map((customer, index) => (
                    <option key={index} value={customer}>
                      {customer}
                    </option>
                  ))}
                </select>
                <label>Customer</label>
              </div>
            </div>

            {/* Date Filters */}
            <div className="col-md-2">
              <div className="form-floating">
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  max={toDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
                <label>From Date</label>
              </div>
            </div>

            <div className="col-md-2">
              <div className="form-floating">
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  min={fromDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
                <label>To Date</label>
              </div>
            </div>

            <div className="col-md-2">
              <button type="button" className="btn btn-success p-3 fw-semibold w-100" onClick={exportToExcel}>
                Export to Excel
              </button>
            </div>
          </div>

          <div className="table-responsive text-center my-2 w-100 position-relative">
            <table className="table table table-sm table-bordered">
              <thead className="table-dark">
                <tr>
                  <th>S.No</th>
                  <th>Date</th>
                  <th>Service NO</th>
                  <th>Customer Name</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.date}</td>
                    <td>{item.service_no}</td>
                    <td>{item.customer_name}</td>
                    <td>{item.total_amount}</td>
                    <td>
                      <div className="d-flex justify-content-center">
                        {item?.purchase_unit == 2 ? (
                          <div className="fw-bold text-danger">UnPaid</div>
                        ) : (
                          <div className="fw-bold text-success">Paid</div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} /> */}
          </div>
        </form>
      </div>
    </div>
  );
};

export default ServiceReport;